import { render } from 'preact';
import { App } from './app';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = document.querySelectorAll('[x-notifier]');

if (root.length > 0) {
  root.forEach((el) => {
    let userIdStr: string | null = el.getAttribute('data-user-id');
    let userId: number | undefined = userIdStr ? Number(userIdStr) : undefined;
    if (!userId) {
      console.error('Missing required attribute: userId');
      return;
    }
    render(
      <QueryClientProvider client={queryClient}>
        <App userId={userId} />
      </QueryClientProvider>,
      el,
    );
  });
}
